import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import * as $ from 'jquery';
import { WebsiteService } from 'src/app/_services/website.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpClient } from "@angular/common/http";
//declare function ire(string,{}): any;
@Component({
  selector: 'app-accomplishments',
  templateUrl: './accomplishments.component.html',
  styleUrls: ['./accomplishments.component.scss']
})
export class AccomplishmentsComponent implements OnInit {
  email: any;
  accomForms: FormGroup;
  latestYear: number = new Date().getFullYear();
  title = 'image-gallery';
  public data1: any = [];
  public data2: any = [];
  public data3: any = [];
  public data1Img: any = [];
  public data2Img: any = [];
  public data3Img: any = [];
  users: any = [];
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private networkCall: WebsiteService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.accomForms = fb.group({
      'accomemailForms': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
    })
  }

  ngOnInit() {
    // this.amplitudeService.logAmplitude('home_page_about_view', {});
    this.titleService.setTitle('Trinka AI | Accomplishments');
    this.metaTagService.updateTag({ name: 'description', content: 'One stop for Trinka`s all accomplishments, latest news, published research, and media assets.' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka AI | Accomplishments' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'One stop for Trinka`s all accomplishments, latest news, published research, and media assets.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/news' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/news' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/accomplishments' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/accomplishments' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/accomplishments' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/accomplishments' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/news' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/accomplishments' });
    this.getData()
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }
  subscribeNow() {
    if (isPlatformBrowser(this.platformId)){
      if (this.accomForms.valid) {
        this.networkCall.postSubscribe(this.accomForms.value.accomemailForms).subscribe(result => {
          this.toastr.success("Subscription successful.");
          this.accomForms.reset();
        }, error => {
          // this.shareService.errorHandller(error);
        })
      } else {
        // this.toastr.warning("Please enter the email address.");
        this.validateAllFormFields(this.accomForms);
      }
    }
  }
  validateAllFormFields(formGroup: FormGroup) {
    if (isPlatformBrowser(this.platformId)){
      Object.keys(formGroup.controls).forEach(field => {  //{2}
        const control = formGroup.get(field);             //{3}
        if (control instanceof FormControl) {             //{4}
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {        //{5}
          this.validateAllFormFields(control);            //{6}
        }
      });
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/branding_logo.js', function () { });
    }
  }
  getData() {
    // const category1 = 'https://www.trinka.ai/blog/wp-json/wp/v2/posts?categories=175';
    const category1 = 'https://www.trinka.ai/blog/wp-json/wp/v2/posts?categories=175';
    const category2 = 'https://www.trinka.ai/blog/wp-json/wp/v2/posts?categories=173';
    const category3 = 'https://www.trinka.ai/blog/wp-json/wp/v2/posts?categories=4';

    const cat1_img = 'https://www.trinka.ai/blog/wp-json/wp/v2/media?parent=';
    this.http.get(category1).subscribe((res1) => {

      //  const mapped = Object.keys(data5).map(key => ({type: key, value: data5[key]}));
      this.data1 = res1[1];
      //console.log(this.data1);
      this.http.get(cat1_img + this.data1.id).subscribe((res1img) => {
        this.data1Img = res1img[1];
        //  console.log(this.data1Img);
        //  console.log("asd");
      });
    });

    this.http.get(category2).subscribe((res2) => {
      this.data2 = res2[0]
      // console.log(this.data2);
      this.http.get(cat1_img + this.data2.id).subscribe((res2img) => {
        this.data2Img = res2img[0];
        //console.log(this.data2Img);
        //console.log("asdasd");
      });
    })
    this.http.get(category3).subscribe((res3) => {
      this.data3 = res3[0]
      //console.log(this.data3);
      this.http.get(cat1_img + this.data3.id).subscribe((res3img) => {
        this.data3Img = res3img[0];
        //console.log(this.data3Img);
        //console.log("asdasdasd");
      });
    })
  }

}
